module.exports = __webpack_public_path__ + "img/logo2_high-school-suzhou.077a92b7.svg";